import React, { useEffect, useState } from "react";
import { ChevronDownIcon } from "components/Icons";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div className="fixed bottom-4 right-4">
      <button
        type="button"
        onClick={scrollToTop}
        className={classNames(
          isVisible ? "opacity-70" : "opacity-0",
          "bg-slate-800 hover:bg-slate-700 focus:ring-slate-500 inline-flex items-center rounded-full p-3 text-white shadow-sm transition-opacity focus:outline-none focus:ring-2 focus:ring-offset-2",
        )}
      >
        <ChevronDownIcon
          className="h-6 w-6 rotate-180 transform fill-current"
          aria-hidden="true"
        />
      </button>
    </div>
  );
};

export default ScrollToTop;
